
import { Component, InjectReactive } from 'vue-property-decorator';
import Vue from 'vue';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import CPOpenAccountFormProse from '../open-account/form/CPOpenAccountFormProse.vue';

@Component({
    components: {
        CPOpenAccountFormSubsection,
        CPOpenAccountFormProse,
    }
})
export default class CPDueDiligenceMoreInformation extends Vue {
    @InjectReactive()
    public readonly viewOnly!: boolean;

    get moreInformation(): string | null {
        return this.$store.state.dueDiligence.details.MoreInformation;
    }

    set moreInformation(val: string) {
        this.$store.commit('dueDiligence/setMoreInformation', val);
    }

    mounted() {
        const fiscalResidenceChanged = this.$store.state.dueDiligence.fiscalResidenceChanged;

        let newInfo = this.moreInformation ?? "";
        if (fiscalResidenceChanged.PrimaryAccountHolder.changed) {
            const { previousCountry, newCountry } = fiscalResidenceChanged.PrimaryAccountHolder;
            const msg = `Primary account holder has changed their fiscal residence from ${this.getCountryName(previousCountry)} to ${this.getCountryName(newCountry)}.`;
            if (!newInfo.includes(msg)) {
                newInfo += (newInfo ? "\n" : "") + msg;
            }
        }

        if (fiscalResidenceChanged.SecondaryAccountHolder.changed) {
            const { previousCountry, newCountry } = fiscalResidenceChanged.SecondaryAccountHolder;
            const msg = `Secondary account holder has changed their fiscal residence from ${this.getCountryName(previousCountry)} to ${this.getCountryName(newCountry)}.`;
            if (!newInfo.includes(msg)) {
                newInfo += (newInfo ? "\n" : "") + msg;
            }
        }

        if (newInfo !== this.moreInformation) {
            this.$store.commit('dueDiligence/setMoreInformation', newInfo);
        }
    }

    getCountryName(countryId: number | null): string {
        if (countryId == null) {
            return 'Not Set';
        }

        const rawCountries = this.$store.getters['dueDiligence/rawCountries'];
        return rawCountries.find((c: { Value: number }) => c.Value === countryId)?.Text ?? 'Unknown';
    }
}
